<template>
    <v-card v-if="!$vuetify.breakpoint.mobile" width="260" tile flat elevation="0" color="#366fd7" class="white--text">
        <v-card-title class="py-30px">
            <span class="tit tit--sm">상품권 교환소</span>
        </v-card-title>
        <v-list>
            <v-list-item-group v-model="category._id" mandatory>
                <v-list-item dense :value="null">
                    <v-list-item-title>상품권 전체</v-list-item-title>
                </v-list-item>
                <v-divider/>
                <v-list-item v-for="category, index in categories" :key="index" :value="category._id" dense>
                    <v-list-item-title>{{ category.name }}</v-list-item-title>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </v-card>
</template>
<script>
import api from "@/api";
export default {
    props: {
        value: { type: Object, default: null },
        returnObject: { type: Boolean, default: false }
    },
    data(){
        return {
            category: this.$props.returnObject ? this.$props.value || { _id: null } : { _id: this.$props.value || null },
            categories: []
        }
    },
    computed:{
        _category(){
            return this.$route.query?._category
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { categories } = await api.v1.gshop.categories.gets({ headers: { limit: 0 }, params: { depth: 0 } });
            this.categories = categories;
            this.sync()
        },
        sync(){
            if(this.category._id != this._category) this.category = ( this.categories || []).find(({_id})=> _id == this._category)
        }
    },
    watch: {
        value(){
            this.category = this.$props.returnObject ? this.value : { _id: this.value || null }
        },
        "category._id"(){
            let category = JSON.parse(JSON.stringify(this.categories.find(category => category._id == this.category._id ) || { _id: null }));
            this.$emit("input", category);
            const {_id:_category} = category
            this.$router.push({query: {_category}})
        },
        _category(){
            this.sync()
        }
    }
}
</script>